import { ref } from "vue";
import { NotificationOptions, MessageOptions } from 'naive-ui';

const _notifications = ref<NotificationOptions[]>([]);
const _toasts = ref<Array<MessageOptions & { title: string, type: string }>>([]);

export {
  _notifications,
  _toasts
};

export class NotificationContent {
  label: string;
  content: string;
};

export const toast = {
  info: (title: string, duration: number = 3000) => { _toasts.value.push({ title: title, duration: duration, type: 'info' }) },
  success: (title: string, duration: number = 3000) => { _toasts.value.push({ title: title, duration: duration, type: 'success' }) },
  warning: (title: string, duration: number = 3000) => { _toasts.value.push({ title: title, duration: duration, type: 'warning' }) },
  error: (title: string, duration: number = 3000) => { _toasts.value.push({ title: title, duration: duration, type: 'error' }) },
  loading: (title: string, duration: number = 10000) => { _toasts.value.push({ title: title, duration: duration, type: 'loading' }) }
};

export const notification = {
  create: (notif: NotificationOptions) => { _notifications.value.push(notif) }
};
